import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { OrderLineShipToComponent } from "../../orders/components/order-line-ship-to/order-line-ship-to.component";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Address } from "../../../core/models/shared/address";
import { ClientPurpose } from "../../../shared/enums/clientPurpose";
import { DrawerModule } from "primeng/drawer";
import { PurchaseOrderHeader } from "../../../core/models/samplePO/details/purchaseOrderHeader";

@Component({
  selector: "jni-address-assignment",
  templateUrl: "./address-assignment.component.html",
  styleUrls: ["./address-assignment.component.scss"],
  imports: [DrawerModule, OrderLineShipToComponent],
})
export class AddressAssignmentComponent implements OnInit {
  @Input() display!: boolean;
  @Input() defaultOneTime = "To Vendor";
  @Input() addressObject: Address = {} as Address;
  @Input() headerObject!: PurchaseOrderHeader;

  @Output() displayChange = new EventEmitter<boolean>();
  @Output() saveEmit = new EventEmitter<{
    addressD365: string;
    addressLocationNumber: number;
    addressSelectionName: string;
    deliveryNameD365: string;
  }>();

  deliveryAddress = [
    {
      id: 1,
      name: "To Vendor",
      status: false,
    },
    {
      id: 2,
      name: "Client Address Book",
      status: false,
    },
    {
      id: 3,
      name: "To Header Ship To",
      status: false,
    },
  ];

  formErrors: Record<string, string> = {
    duplicateVendorDirectDelivery: "",
    itemNumberD365: "",
    orderedPurchaseQuantityD365: "",
    vendorPoAssignment: "",
    shipDate: "",
    inHandDate: "",
    addressSelectionName: "",
    deliveryNameD365: "",
  };

  form: FormGroup;

  @ViewChild("shipTo", { static: false })
  shipTo!: OrderLineShipToComponent;

  constructor(private _formBuilder: FormBuilder) {
    this.form = this._formBuilder.group({
      shipTo: this._formBuilder.group({
        deliveryAddress: [""],
        attention: [""],
        countryRegionIdD365: ["", Validators.required],
        zipCodeD365: [{ value: "", disabled: true }, Validators.required],
        cityD365: [{ value: "", disabled: true }],
        stateD365: [{ value: "", disabled: true }],
        addressD365: [""],
        streetD365: [""],
        purposeD365: ClientPurpose.Business,
        isPrimaryD365: "1",
        addressBook: [""],
        buildingComplimentD365: [""],
        apartment_RUD365: [""],
        postBoxD365: [""],
        countyD365: [""],
        streetNumberD365: [""],
        districtNameD365: [""],
        shipToEmailAddress: [""],
        addressSelectionName: ["", Validators.required],
        locationD365: [""],
        addressLocationNumber: [0],
        shipToVendorAccountD365: [""],
        shipToVendorAccountNameD365: [""],
        validateAddress: [""],
        addressFormat: [""],
        rSMJNIShipToEmailD365: [""],
        attentionInformationD365: [""],
        melissaAddressKeyD365: [""],
        addressLine1: [""],
        addressLine2: [""],
        addressLine3: [""],
        deliveryNameD365: ["", Validators.maxLength(100)],
      }),
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.shipTo.onDeliveryAddressChange("To Vendor");
    }, 0);
  }

  onSubmit() {
    const { shipTo } = this.form.getRawValue();

    if (shipTo) {
      this.saveEmit.emit({
        addressD365: shipTo.addressD365,
        addressLocationNumber: shipTo.addressLocationNumber,
        addressSelectionName: shipTo.addressSelectionName,
        deliveryNameD365: shipTo.deliveryNameD365,
      });
    }

    this.displayChange.emit(false);
  }

  onHide() {
    this.displayChange.emit(false);
  }
}
